import { render, staticRenderFns } from "./NovelList.vue?vue&type=template&id=3673de4c&scoped=true"
import script from "./NovelList.vue?vue&type=script&lang=ts"
export * from "./NovelList.vue?vue&type=script&lang=ts"
import style0 from "./NovelList.vue?vue&type=style&index=0&id=3673de4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673de4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3673de4c')) {
      api.createRecord('3673de4c', component.options)
    } else {
      api.reload('3673de4c', component.options)
    }
    module.hot.accept("./NovelList.vue?vue&type=template&id=3673de4c&scoped=true", function () {
      api.rerender('3673de4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NovelList.vue"
export default component.exports